import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { CheckCircleIcon, ExclamationCircleIcon } from 'components/icons';
import { useAppSelector } from 'hooks';

import { getTotalShareBasisPoints } from '../utils';
import { getOwners } from '../selectors';

const TotalBreakdown = () => {
  const { t } = useTranslation('ownership');

  const owners = useAppSelector(getOwners);

  const basisPoints = getTotalShareBasisPoints(owners);
  const isComplete = basisPoints === 10000;

  return (
    <div className="flex items-center justify-end mt-5">
      <span className="text-sm text-gray-500 mr-2">
        {t('ownership:totalBreakdown')}
      </span>
      <span
        className={classNames(
          'text-sm font-medium',
          isComplete ? 'text-gray-900' : 'text-red-600',
        )}
      >
        {basisPoints / 100}
      </span>
      <span className="text-sm text-gray-500">
        {t('ownership:totalBreakdownLimit')}
      </span>
      {isComplete ? (
        <CheckCircleIcon className="ml-2 text-green-500" />
      ) : (
        <ExclamationCircleIcon className="ml-2 text-red-600" />
      )}
    </div>
  );
};

export default TotalBreakdown;
